import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';

const Contact = () => {
    const { t } = useLanguage();
    return (
        <Box>
            <Toolbar>
                <div className='diclaimer-Screen'>
                    <div className='disclainerWrapper'>
                        <Typography variant='h2'>{t('contact_title')}</Typography>
                        <div className='tems-condition-content'>
                            <Typography variant='body1' sx={{ py: '30px' }}>{t('contact_text')}
                            </Typography>
                        </div>
                    </div>
                </div>
            </Toolbar>
        </Box>
    );
};

export default Contact;